import {
  Actions,
  Button,
  IconCritical,
  Inline,
  Text,
} from 'braid-design-system';

interface SubmitProps {
  terminateIntegration?: boolean;
}

export const Submit = ({ terminateIntegration }: SubmitProps) => (
  <Inline space="small" alignY="center">
    <Actions>
      <Button tone="brandAccent" type="submit" id="security-breach-submit">
        Submit
      </Button>
    </Actions>
    {terminateIntegration ? (
      <Text tone="critical" weight="strong" icon={<IconCritical />}>
        Your integration will be shut off by invalidating your credentials with
        SEEK. All users associated with your account will be locked out of the
        dashboard. SEEK will contact you to discuss further.
      </Text>
    ) : (
      <Text tone="info">SEEK will contact you to discuss further.</Text>
    )}
  </Inline>
);
